import React from "react";
import { scroller } from "react-scroll";
import HeroVisual from "./HeroVisual";

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-noise" aria-hidden="true" />
      <div className="hero-grid" aria-hidden="true" />
      <div className="hero-glow hero-glow--a" />
      <div className="hero-glow hero-glow--b" />

      <div className="hero-content container">
        <div className="hero-left">
          <p className="hero-eyebrow">Web · Mobile iOS & Android · AI</p>

          <h1 className="hero-title">
            Zgjidhje dixhitale që{" "}
            <span className="hero-title-accent">rrisin biznesin tuaj</span>
          </h1>

          <p className="hero-lead">
            TechTalent është agjencia juaj teknologjike — ndërtojmë faqe web,
            aplikacione mobile (iOS &amp; Android) dhe integrojmë Inteligjencën
            Artificiale në proceset tuaja. Nga ideja deri te lançimi, me çmime
            transparente dhe dorëzim në kohë.
          </p>

          <ul className="hero-proof" aria-label="Pse na zgjedhin klientët">
            <li>Ekip me eksperiencë të vërtetë</li>
            <li>Çmime të qarta pa kosto të fshehura</li>
            <li>Mbështetje pas dorëzimit të projektit</li>
            <li>Integrim AI për automatizim</li>
          </ul>

          <div className="hero-buttons">
            <button
              type="button"
              className="primary-btn"
              onClick={() =>
                scroller.scrollTo("contact", {
                  smooth: true,
                  duration: 550,
                  offset: -96,
                })
              }
            >
              Fillo projektin tënd
            </button>

            <button
              type="button"
              className="secondary-btn"
              onClick={() =>
                scroller.scrollTo("pricing", {
                  smooth: true,
                  duration: 550,
                  offset: -96,
                })
              }
            >
              Shiko çmimet
            </button>
          </div>
        </div>

        <HeroVisual />
      </div>
    </section>
  );
}

export default Hero;
